import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "IT Impact",
    date: "30 July, 2025",
    admin: "Admin",
    heading: "How IT Has Changed the World",
    content: "Information Technology (IT) continues to reshape how we live and work.",
    important: {
      content: "From communication and healthcare to education and business, IT continues to redefine human progress and shape a digital-first future.",
      intro: "IT Specialist"
    },
    paragraph: {
      para1: "The rise of the internet and mobile technologies has made global communication instantaneous and seamless. Social media, messaging apps, and video calls have transformed personal and professional connections.",
      para2: "In healthcare, IT has improved patient care with electronic medical records, telemedicine, and advanced diagnostic tools, enabling faster and more accurate treatments.",
      para3: "Education has become more accessible than ever. Online learning platforms, virtual classrooms, and digital libraries are empowering students across the globe regardless of location.",
      para4: "Businesses now rely on IT for everything from data management and automation to cybersecurity and remote work. This digital transformation has led to greater efficiency, innovation, and global reach."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2,
      images.blog1Gallery3,
      images.blog1Gallery4,
      images.blog1Gallery5,
      images.blog1Gallery6,
    ],
    tags: ["Technology", "Business", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "James Anderson",
        date: "16 October, 2024",
        content: "Incredible how IT has reshaped our everyday lives. We're truly living in a digital age!",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Olivia Martinez",
            date: "17 October, 2024",
            content: "Totally agree! Especially in education and healthcare — the changes are life-changing."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Daniel Carter",
        date: "18 October, 2024",
        content: "The impact on remote work alone has been huge. IT made global collaboration possible."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Programming Trends",
    date: "22 July, 2025",
    admin: "Admin",
    heading: "Up and Coming Programming Languages",
    content: "New programming languages are transforming software development daily.",
    important: {
      content: "Explore the rising stars in the programming world — languages that are gaining popularity for their efficiency, modern syntax, and ability to solve complex problems.",
      intro: "Tech Analyst"
    },
    paragraph: {
      para1: "Languages like Rust are gaining traction for their memory safety and speed, making them ideal for system-level programming and performance-critical applications.",
      para2: "Kotlin is continuing to grow in popularity, especially for Android development, due to its concise syntax and full interoperability with Java.",
      para3: "Go, developed by Google, is known for its simplicity and efficiency in building scalable web applications and microservices.",
      para4: "Other languages like Swift, TypeScript, and Julia are also emerging in specific domains — from mobile app development to scientific computing and data science."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2,
      images.blog2Gallery3,
      images.blog2Gallery4,
      images.blog2Gallery5,
      images.blog2Gallery6,
    ],
    tags: ["Programming", "Technology", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Sophia Lin",
        date: "23 April, 2025",
        content: "Rust has been on my radar for a while — finally started learning it and I love the focus on safety!",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Liam Chen",
            date: "24 April, 2025",
            content: "Same here! It’s a bit of a learning curve, but totally worth it for system programming."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Ava Johnson",
        date: "25 April, 2025",
        content: "Great summary! I’ve been using Go and it’s fantastic for backend services."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Tech Events",
    date: "15 July, 2025",
    admin: "Admin",
    heading: "5 Upcoming Tech Events to Attend in 2025",
    content: "Major tech events in 2025 will spotlight innovation and growth.",
    important: {
      content: "From AI to cybersecurity to Web3, these global events bring together innovators and leaders to shape the future of technology.",
      intro: "Event Curator"
    },
    paragraph: {
      para1: "CES (Consumer Electronics Show) 2025 — The world’s largest tech trade show debuted major innovations in consumer electronics, automotive tech, and more.",
      para2: "Google I/O 2025 — Google unveiled significant updates to Android, AI services, and developers got hands-on with new tools and APIs.",
      para3: "Microsoft Build 2025 — Focused on software development and cloud solutions, Microsoft shared key announcements around Azure, DevOps, and productivity apps.",
      para4: "Web Summit 2025 — Held in Lisbon, this event covered a wide range of topics from digital marketing and startups to deep discussions on the future of Web3.",
      para5: "Black Hat USA 2025 — A highlight for cybersecurity professionals, offering technical trainings, talks on vulnerabilities, and hands-on workshops."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2,
      images.blog3Gallery3,
      images.blog3Gallery4,
      images.blog3Gallery5,
      images.blog3Gallery6,
    ],
    tags: ["Events", "Technology", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Michael Roberts",
        date: "6 May, 2025",
        content: "Even though these are past events, it's interesting to look back on what topics were trending then.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Emma Clark",
            date: "7 May, 2025",
            content: "I hope these conferences come back this year — especially the Web Summit sessions on Web3!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Carlos Diaz",
        date: "8 May, 2025",
        content: "Great recap! Black Hat USA always has incredible security deep dives."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Small Business",
    date: "10 July, 2025",
    admin: "Admin",
    heading: "Best Software for Small Businesses",
    content: "Small businesses thrive with software that boosts daily operations.",
    important: {
      content: "From accounting to project management, explore essential software tools every small business should consider for smooth and scalable operations.",
      intro: "Business Advisor"
    },
    paragraph: {
      para1: "QuickBooks is one of the most trusted accounting tools for small businesses. It simplifies invoicing, payroll, expense tracking, and financial reporting.",
      para2: "Trello and Asana are excellent project management tools that allow small teams to collaborate, assign tasks, and track progress visually.",
      para3: "Zoho CRM and HubSpot CRM help small businesses manage customer relationships, automate sales processes, and improve client communication.",
      para4: "For communication, Slack and Microsoft Teams provide powerful chat, call, and file-sharing capabilities to keep teams connected.",
      para5: "Canva and Adobe Express empower businesses with simple yet professional graphic design tools for marketing materials, social media, and branding."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2,
      images.blog4Gallery3,
      images.blog4Gallery4,
      images.blog4Gallery5,
      images.blog4Gallery6,
    ],
    tags: ["Business", "Software", "Tools"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Nina Patel",
        date: "11 May, 2025",
        content: "Great list! I use QuickBooks and Canva almost daily — both are incredibly useful.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Mark Benson",
            date: "12 May, 2025",
            content: "Trello helped my team stay organized without the complexity of bigger platforms."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Linda Xu",
        date: "13 May, 2025",
        content: "Would love to see a follow-up on the best free tools for startups!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Productivity Apps",
    date: "28 June, 2025",
    admin: "Admin",
    heading: "Apps You Use in Your Day-to-Day Functions",
    content: "Everyday apps simplify work, communication, and personal routines.",
    important: {
      content: "Discover the must-have apps that help professionals and individuals stay organized, productive, and stress-free in their daily routines.",
      intro: "Productivity Coach"
    },
    paragraph: {
      para1: "To-do list apps like Todoist and Microsoft To Do make it easier to organize tasks, set priorities, and manage daily responsibilities.",
      para2: "Calendar tools such as Google Calendar and Outlook keep your schedule in check, with reminders and syncing across devices.",
      para3: "Note-taking apps like Notion and Evernote help capture ideas, meeting notes, and personal journals, all in one place.",
      para4: "For communication, apps like WhatsApp, Zoom, and Slack are vital for staying in touch with colleagues, clients, and friends.",
      para5: "Health and wellness apps like MyFitnessPal or Headspace support better physical and mental well-being with tracking and guided activities."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2,
      images.blog5Gallery3,
      images.blog5Gallery4,
      images.blog5Gallery5,
      images.blog5Gallery6,
    ],
    tags: ["Productivity", "Tools", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Rachel Moore",
        date: "21 May, 2025",
        content: "I can't live without Google Calendar and Notion—absolutely essential for juggling work and personal life!",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Jason Lee",
            date: "22 May, 2025",
            content: "Same! I use Todoist daily and it's a game-changer for task management."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Emily Carter",
        date: "23 May, 2025",
        content: "Great suggestions! Would love to see a version focused on student life apps too."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Small Business",
    date: "20 June, 2025",
    admin: "Admin",
    heading: "Budgeting for IT-Related Purchases",
    content: "Smart budgeting for IT gear ensures efficient and affordable upgrades.",
    important: {
      content: "Learn how to create an effective budget for IT needs by prioritizing essential tools, evaluating long-term ROI, and avoiding unnecessary overspending.",
      intro: "IT Finance Consultant"
    },
    paragraph: {
      para1: "Start by identifying the core IT needs of your business—this could include computers, servers, networking equipment, or security systems.",
      para2: "Distinguish between one-time costs (like hardware) and recurring expenses (like software licenses, cloud services, or maintenance).",
      para3: "Evaluate total cost of ownership by considering not just the initial purchase but ongoing support, upgrades, and potential downtime.",
      para4: "Set a flexible IT budget that allows for unexpected changes such as security updates, new technologies, or scaling needs.",
      para5: "Use budgeting software or spreadsheets to track expenses, compare vendor quotes, and allocate funds based on department priorities."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2,
      images.blog6Gallery3,
      images.blog6Gallery4,
      images.blog6Gallery5,
      images.blog6Gallery6,
    ],
    tags: ["Business", "Software", "Productivity"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Kevin Turner",
        date: "29 May, 2025",
        content: "This is so helpful! I’ve always struggled with planning IT expenses, especially subscriptions.",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Fatima Noor",
            date: "30 May, 2025",
            content: "Yes! Tracking total cost of ownership really changed how I approach IT spending."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Robert James",
        date: "31 May, 2025",
        content: "Would love to see a budgeting template included in a future post. Great content!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "IT Impact",
    date: "11 June, 2025",
    admin: "Admin",
    heading: "The Impact of IT on Modern Life",
    content: "IT influences modern living through automation, access, and speed.",
    important: {
      content: "From virtual collaboration to smart homes and instant access to information, IT’s influence is visible in every aspect of modern living.",
      intro: "Tech Culture Writer"
    },
    paragraph: {
      para1: "In the workplace, IT enables remote collaboration, cloud computing, and automation, increasing productivity and reshaping job roles across industries.",
      para2: "On a personal level, everyday conveniences like online banking, smart assistants, and mobile apps are powered by IT, simplifying daily tasks.",
      para3: "IT has revolutionized how we access information and entertainment—from e-learning platforms to on-demand streaming services, knowledge and leisure are just a click away.",
      para4: "Healthcare systems have advanced with IT through digital health records, AI-assisted diagnostics, and telemedicine, enhancing both accessibility and quality of care.",
      para5: "Despite its benefits, IT also brings challenges like screen fatigue, privacy concerns, and digital dependency—making balance and awareness essential."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2,
      images.blog7Gallery3,
      images.blog7Gallery4,
      images.blog7Gallery5,
      images.blog7Gallery6,
    ],
    tags: ["Technology", "Innovation", "Business"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Isla Ahmed",
        date: "6 June, 2025",
        content: "Well said! IT has changed so many things for the better—but we do need to manage its downsides too.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Raymond Blake",
            date: "7 June, 2025",
            content: "Absolutely. The convenience is amazing, but I’m trying to cut back on screen time myself."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Priya Malhotra",
        date: "8 June, 2025",
        content: "Love the balanced perspective. IT is everywhere—this captures its impact well!"
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Programming Trends",
    date: "3 June, 2025",
    admin: "Admin",
    heading: "Emerging Programming Languages to Watch",
    content: "Innovative coding languages are changing how systems are built.",
    important: {
      content: "Keep an eye on these up-and-coming languages that are gaining attention in developer communities for their innovation, clarity, and practical applications.",
      intro: "Software Engineer"
    },
    paragraph: {
      para1: "Rust continues to grow in popularity due to its focus on memory safety and high performance, making it ideal for systems-level programming and large-scale applications.",
      para2: "Zig is a low-level language that's catching attention for its simplicity and ability to replace C in many performance-critical environments.",
      para3: "Elixir, built on the Erlang VM, is making waves in real-time systems and web applications thanks to its scalability and fault tolerance.",
      para4: "Crystal offers the speed of C with the elegance of Ruby, appealing to developers who want performance without sacrificing readable syntax.",
      para5: "Other notable mentions include Nim, Red, and Ballerina—each solving specific niche problems while building strong developer ecosystems."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2,
      images.blog8Gallery3,
      images.blog8Gallery4,
      images.blog8Gallery5,
      images.blog8Gallery6,
    ],
    tags: ["Programming", "Innovation", "Tools"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Leo Fernandez",
        date: "13 June, 2025",
        content: "Rust is incredible! I've been using it for a year and it's now my favorite for backend work.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Natalie Brooks",
            date: "14 June, 2025",
            content: "Crystal sounds interesting—I’ll check it out. Thanks for the list!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Hassan Rehman",
        date: "15 June, 2025",
        content: "Great overview! Hope you do a follow-up post with example projects for each language."
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Tech Events",
    date: "18 May, 2025",
    admin: "Admin",
    heading: "Top 5 Must-Attend Tech Events of 2025",
    content: "These 2025 events promise the latest in global tech trends.",
    important: {
      content: "Explore five of the most anticipated tech conferences of 2025 where the future of technology will be shaped, shared, and experienced.",
      intro: "Event Analyst"
    },
    paragraph: {
      para1: "**CES 2025 (Las Vegas, USA)** – This iconic event showcases consumer electronics, AI tools, and the latest breakthroughs in smart technology.",
      para2: "**MWC Barcelona 2025** – A hub for mobile innovation, 5G developments, and digital transformation in telecom and beyond.",
      para3: "**Google I/O 2025 (Mountain View, USA)** – A developer-focused conference covering Android, AI, and Google Cloud innovations.",
      para4: "**Web Summit 2025 (Lisbon, Portugal)** – A global gathering of startups, investors, and tech leaders discussing web trends, AI, and social tech.",
      para5: "**DEF CON 33 (Las Vegas, USA)** – One of the world’s largest hacker conventions focused on cybersecurity, digital rights, and ethical hacking."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2,
      images.blog9Gallery3,
      images.blog9Gallery4,
      images.blog9Gallery5,
      images.blog9Gallery6,
    ],
    tags: ["Events", "Technology", "Programming"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Arjun Mehta",
        date: "19 June, 2025",
        content: "I’m planning to attend Web Summit this year — the sessions on AI startups are always insightful!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Sara Kim",
            date: "20 June, 2025",
            content: "Same here! It’s such a great event for networking and exposure to global tech trends."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Oliver Grant",
        date: "21 June, 2025",
        content: "Great list! DEF CON is a personal favorite — always exciting and eye-opening."
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Small Business",
    date: "6 May, 2025",
    admin: "Admin",
    heading: "Top Software Tools for Small Business Success",
    content: "The right tools help small businesses run smoother and scale faster.",
    important: {
      content: "From financial management to marketing automation, these essential tools empower small businesses to run efficiently and compete with larger players.",
      intro: "Business Tech Strategist"
    },
    paragraph: {
      para1: "For accounting, **QuickBooks** and **Xero** offer robust invoicing, expense tracking, and payroll features tailored for small business needs.",
      para2: "**HubSpot CRM** and **Zoho CRM** help businesses manage customer relationships, track sales pipelines, and automate communications effectively.",
      para3: "**Trello**, **Asana**, and **ClickUp** are project management tools that enhance team collaboration, task tracking, and deadline management.",
      para4: "To support marketing, **Mailchimp** and **Buffer** offer user-friendly platforms for email campaigns, social media scheduling, and audience analytics.",
      para5: "**Google Workspace** and **Microsoft 365** remain top choices for document sharing, communication, and productivity in any modern business environment."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2,
      images.blog10Gallery3,
      images.blog10Gallery4,
      images.blog10Gallery5,
      images.blog10Gallery6,
    ],
    tags: ["Business", "Software", "Tools"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Elena Rodriguez",
        date: "26 June, 2025",
        content: "QuickBooks and Mailchimp have been lifesavers for my boutique shop. Great picks!",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Noah Wright",
            date: "27 June, 2025",
            content: "Agreed. I added ClickUp last year and it’s helped us organize everything from client work to inventory."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Mina Patel",
        date: "28 June, 2025",
        content: "Would love to see an updated list of free vs. paid software options for startups too."
      }
    ]
  }

];

export default blogs;